import React from 'react';
import { connect } from 'react-redux';
import { deleteGroup, resetGroupForm } from '../../../../actions/group';
import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage';

@connect()
export default class RightPanelDelete extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      groupForm: props.groupForm,
    };
  }
  UNSAFE_componentWillReceiveProps = (props) => {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({ groupForm: props.groupForm });
  };
  deletecurrentGroup = () => {
    let cb = () => {
      window.$('.delete-group.modal').modal('hide');
      setTimeout(() => {
        this.resetForm();
      }, 500); //timeout waiting for the hide effect to finish
    };
    this.props.dispatch(deleteGroup(this.state.groupForm, cb));
  };

  componentDidMount = () => {
    this.resetForm();
  };

  closeModal = () => {
    window.$('.view-group.modal').modal('hide');
    setTimeout(() => {
      this.resetForm();
    }, 500); //timeout waiting for the hide effect to finish
  };

  cancelDeleteGroup = () => {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) this.props.dispatch(hideGlobalMessage());
    window.$('.delete-group.modal').modal('hide');
    setTimeout(() => {
      this.resetForm();
    }, 500); //timeout waiting for the hide effect to finish
  };

  resetForm = () => {
    setTimeout(() => {
      this.props.dispatch(resetGroupForm());
    }, 500); //wait until hide animation finishes
  };

  render() {
    let saveClasses =
      'ui approve labeled icon button icon left-text color-button color-button-hover mrrxs color-white max-width  mrlnull mrbnull';

    return (
      <div className=" mrbs max-width mrtm ">
        <button
          type="button"
          onClick={this.deletecurrentGroup}
          className={this.state.groupForm && this.state.groupForm.saving ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Yes} <i className="checkmark icon " />
        </button>
        <button
          onClick={this.cancelDeleteGroup}
          type="button"
          className="ui cancel labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.No}
        </button>
      </div>
    );
  }
}
